// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vkb {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    background-color: var(--color-bg);
    border-top: 1px solid var(--color-border);
    padding: 6px 4px 10px;
    display: flex;
    flex-direction: column;
    gap: 6px;
    touch-action: manipulation;
    user-select: none;
    transition: transform 0.25s ease;
}

.vkb--collapsed {
    transform: translateY(calc(100% - 32px));
}

/* Splitter bar — always visible, sits at the very top of the VKB */

.vkb__splitter {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 32px;
    margin: -6px -4px 0;
    padding: 0 8px;
    cursor: pointer;
    background-color: var(--color-bg-2);
    border-bottom: 1px solid var(--color-border);
    gap: 8px;
    -webkit-tap-highlight-color: transparent;
    transition: background-color 0.15s;
}

@media (pointer: fine) {
    .vkb__splitter:hover {
        background-color: var(--color-bg-3);
    }
}

.vkb__splitter_control {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
}

.vkb__splitter_chevron {
    flex-shrink: 0;
    width: 28px;
    height: 4px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}

.vkb__splitter_chevron::before,
.vkb__splitter_chevron::after {
    content: "";
    position: absolute;
    width: 10px;
    height: 2px;
    background-color: var(--color-text-muted);
    border-radius: 1px;
    transition: transform 0.25s ease, background-color 0.15s;
}

/* Visible state: chevron points down (∨) — press to collapse */
.vkb__splitter_chevron::before {
    transform: translateX(-4px) rotate(35deg);
}

.vkb__splitter_chevron::after {
    transform: translateX(4px) rotate(-35deg);
}

/* Collapsed state: chevron points up (∧) — press to expand */
.vkb__splitter--collapsed .vkb__splitter_chevron::before {
    transform: translateX(-4px) rotate(-35deg);
}

.vkb__splitter--collapsed .vkb__splitter_chevron::after {
    transform: translateX(4px) rotate(35deg);
}

.vkb__splitter--collapsed .vkb__splitter_chevron::before,
.vkb__splitter--collapsed .vkb__splitter_chevron::after {
    background-color: var(--color-accent);
}

.vkb__row {
    display: flex;
    justify-content: center;
    gap: 5px;
}

.vkb__key {
    flex: 1;
    max-width: 42px;
    height: 42px;
    background-color: var(--color-bg-3);
    border: 1px solid var(--color-border);
    border-radius: 5px;
    color: var(--color-text);
    font-size: 16px;
    font-family: inherit;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    transition: background-color 0.08s, opacity 0.08s;
    -webkit-tap-highlight-color: transparent;
}

.vkb__key--pressed {
    background-color: var(--color-accent);
    color: #fff;
    border-color: var(--color-accent);
}

.vkb__key--active {
    background-color: color-mix(in srgb, var(--color-accent) 20%, var(--color-bg-3));
    border-color: var(--color-accent);
    color: var(--color-accent);
}

/* Wider action keys */

.vkb__key--shift,
.vkb__key--backspace {
    max-width: none;
    flex: 1.5;
    font-size: 18px;
    background-color: var(--color-bg-2);
    color: var(--color-text-muted);
}

.vkb__key--layer {
    max-width: none;
    flex: 1.4;
    font-size: 13px;
    background-color: var(--color-bg-2);
    color: var(--color-text-muted);
}

.vkb__key--space {
    max-width: none;
    flex: 4;
    font-size: 13px;
    color: var(--color-text-muted);
}

.vkb__key--enter {
    max-width: none;
    flex: 1.8;
    font-size: 18px;
    background-color: var(--color-accent);
    border-color: var(--color-accent);
    color: #fff;
}

.vkb__key--enter.vkb__key--pressed {
    opacity: 0.8;
}

/* Embedded text mirror shown when the keyboard overlaps the trigger input */

.vkb__embedded_input {
    min-height: 38px;
    padding: 6px 10px;
    background-color: var(--color-bg-2);
    border: 1px solid var(--color-border);
    border-radius: 6px;
    margin: 0 4px 2px;
    overflow-x: scroll;
    /* single-line scroll so the cursor follows the text */
    white-space: nowrap;
    /* hide scrollbar on all browsers */
    scrollbar-width: none;
    display: flex;
    align-items: center;
}

.vkb__embedded_input::-webkit-scrollbar {
    display: none;
}

/* Multi-line embedded input — wraps text like a textarea */

.vkb__embedded_input--multiline {
    white-space: pre-wrap;
    word-break: break-word;
    overflow-x: hidden;
    overflow-y: auto;
    display: block;
    /* Fixed height derived from line count via CSS variable set inline */
    height: calc(var(--vkb-lines, 3) * 1.5em + 12px);
    min-height: unset;
    align-items: unset;
    scrollbar-width: none;
}

.vkb__embedded_input--multiline::-webkit-scrollbar {
    display: none;
}


/* Mobile portrait: shift up by the activity bar height unless a transformed ancestor
   already acts as the containing block (in which case --vkb-bottom is set to 0 there). */
@media (max-width: 845px) and (orientation: portrait) {
    .vkb {
        bottom: var(--vkb-bottom, 62px);
    }
}

/* Mobile landscape: shorter keys, generic keys fill available width. */
@media (orientation: landscape) and (max-height: 500px) {
    .vkb {
        padding: 4px 4px 6px;
        gap: 4px;
        /* left: 0 — on narrow phones (≤768px) the section has a CSS transform which makes it
           the fixed-positioning containing block; the section already starts after the ActivityBar. */
    }

    .vkb__key {
        height: 31px;
        max-width: none;
    }
}

/* Wider landscape phones (>768px): isMobile=false means no section transforms, so the VKB
   is viewport-relative and must skip past the ActivityBar (53px, border-box). */
@media (orientation: landscape) and (max-height: 500px) and (min-width: 769px) {
    .vkb {
        left: 53px;
    }
}
`, "",{"version":3,"sources":["webpack://./components/toolkit/VirtualKeyboard/s.virtual_keyboard.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,aAAa;IACb,iCAAiC;IACjC,yCAAyC;IACzC,qBAAqB;IACrB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,0BAA0B;IAC1B,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA,mEAAmE;;AAEnE;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,mCAAmC;IACnC,4CAA4C;IAC5C,QAAQ;IACR,wCAAwC;IACxC,kCAAkC;AACtC;;AAEA;IACI;QACI,mCAAmC;IACvC;AACJ;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,yCAAyC;IACzC,kBAAkB;IAClB,wDAAwD;AAC5D;;AAEA,+DAA+D;AAC/D;IACI,yCAAyC;AAC7C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA,6DAA6D;AAC7D;IACI,0CAA0C;AAC9C;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;;IAEI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,OAAO;IACP,eAAe;IACf,YAAY;IACZ,mCAAmC;IACnC,qCAAqC;IACrC,kBAAkB;IAClB,wBAAwB;IACxB,eAAe;IACf,oBAAoB;IACpB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,iDAAiD;IACjD,wCAAwC;AAC5C;;AAEA;IACI,qCAAqC;IACrC,WAAW;IACX,iCAAiC;AACrC;;AAEA;IACI,gFAAgF;IAChF,iCAAiC;IACjC,0BAA0B;AAC9B;;AAEA,sBAAsB;;AAEtB;;IAEI,eAAe;IACf,SAAS;IACT,eAAe;IACf,mCAAmC;IACnC,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,SAAS;IACT,eAAe;IACf,mCAAmC;IACnC,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,OAAO;IACP,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,SAAS;IACT,eAAe;IACf,qCAAqC;IACrC,iCAAiC;IACjC,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA,4EAA4E;;AAE5E;IACI,gBAAgB;IAChB,iBAAiB;IACjB,mCAAmC;IACnC,qCAAqC;IACrC,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,sDAAsD;IACtD,mBAAmB;IACnB,mCAAmC;IACnC,qBAAqB;IACrB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA,2DAA2D;;AAE3D;IACI,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,qEAAqE;IACrE,gDAAgD;IAChD,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;;AAGA;yFACyF;AACzF;IACI;QACI,+BAA+B;IACnC;AACJ;;AAEA,uEAAuE;AACvE;IACI;QACI,oBAAoB;QACpB,QAAQ;QACR;sGAC8F;IAClG;;IAEA;QACI,YAAY;QACZ,eAAe;IACnB;AACJ;;AAEA;gFACgF;AAChF;IACI;QACI,UAAU;IACd;AACJ","sourcesContent":[".vkb {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 1000;\n    background-color: var(--color-bg);\n    border-top: 1px solid var(--color-border);\n    padding: 6px 4px 10px;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    touch-action: manipulation;\n    user-select: none;\n    transition: transform 0.25s ease;\n}\n\n.vkb--collapsed {\n    transform: translateY(calc(100% - 32px));\n}\n\n/* Splitter bar — always visible, sits at the very top of the VKB */\n\n.vkb__splitter {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 32px;\n    margin: -6px -4px 0;\n    padding: 0 8px;\n    cursor: pointer;\n    background-color: var(--color-bg-2);\n    border-bottom: 1px solid var(--color-border);\n    gap: 8px;\n    -webkit-tap-highlight-color: transparent;\n    transition: background-color 0.15s;\n}\n\n@media (pointer: fine) {\n    .vkb__splitter:hover {\n        background-color: var(--color-bg-3);\n    }\n}\n\n.vkb__splitter_control {\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    align-items: center;\n}\n\n.vkb__splitter_chevron {\n    flex-shrink: 0;\n    width: 28px;\n    height: 4px;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.vkb__splitter_chevron::before,\n.vkb__splitter_chevron::after {\n    content: \"\";\n    position: absolute;\n    width: 10px;\n    height: 2px;\n    background-color: var(--color-text-muted);\n    border-radius: 1px;\n    transition: transform 0.25s ease, background-color 0.15s;\n}\n\n/* Visible state: chevron points down (∨) — press to collapse */\n.vkb__splitter_chevron::before {\n    transform: translateX(-4px) rotate(35deg);\n}\n\n.vkb__splitter_chevron::after {\n    transform: translateX(4px) rotate(-35deg);\n}\n\n/* Collapsed state: chevron points up (∧) — press to expand */\n.vkb__splitter--collapsed .vkb__splitter_chevron::before {\n    transform: translateX(-4px) rotate(-35deg);\n}\n\n.vkb__splitter--collapsed .vkb__splitter_chevron::after {\n    transform: translateX(4px) rotate(35deg);\n}\n\n.vkb__splitter--collapsed .vkb__splitter_chevron::before,\n.vkb__splitter--collapsed .vkb__splitter_chevron::after {\n    background-color: var(--color-accent);\n}\n\n.vkb__row {\n    display: flex;\n    justify-content: center;\n    gap: 5px;\n}\n\n.vkb__key {\n    flex: 1;\n    max-width: 42px;\n    height: 42px;\n    background-color: var(--color-bg-3);\n    border: 1px solid var(--color-border);\n    border-radius: 5px;\n    color: var(--color-text);\n    font-size: 16px;\n    font-family: inherit;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    transition: background-color 0.08s, opacity 0.08s;\n    -webkit-tap-highlight-color: transparent;\n}\n\n.vkb__key--pressed {\n    background-color: var(--color-accent);\n    color: #fff;\n    border-color: var(--color-accent);\n}\n\n.vkb__key--active {\n    background-color: color-mix(in srgb, var(--color-accent) 20%, var(--color-bg-3));\n    border-color: var(--color-accent);\n    color: var(--color-accent);\n}\n\n/* Wider action keys */\n\n.vkb__key--shift,\n.vkb__key--backspace {\n    max-width: none;\n    flex: 1.5;\n    font-size: 18px;\n    background-color: var(--color-bg-2);\n    color: var(--color-text-muted);\n}\n\n.vkb__key--layer {\n    max-width: none;\n    flex: 1.4;\n    font-size: 13px;\n    background-color: var(--color-bg-2);\n    color: var(--color-text-muted);\n}\n\n.vkb__key--space {\n    max-width: none;\n    flex: 4;\n    font-size: 13px;\n    color: var(--color-text-muted);\n}\n\n.vkb__key--enter {\n    max-width: none;\n    flex: 1.8;\n    font-size: 18px;\n    background-color: var(--color-accent);\n    border-color: var(--color-accent);\n    color: #fff;\n}\n\n.vkb__key--enter.vkb__key--pressed {\n    opacity: 0.8;\n}\n\n/* Embedded text mirror shown when the keyboard overlaps the trigger input */\n\n.vkb__embedded_input {\n    min-height: 38px;\n    padding: 6px 10px;\n    background-color: var(--color-bg-2);\n    border: 1px solid var(--color-border);\n    border-radius: 6px;\n    margin: 0 4px 2px;\n    overflow-x: scroll;\n    /* single-line scroll so the cursor follows the text */\n    white-space: nowrap;\n    /* hide scrollbar on all browsers */\n    scrollbar-width: none;\n    display: flex;\n    align-items: center;\n}\n\n.vkb__embedded_input::-webkit-scrollbar {\n    display: none;\n}\n\n/* Multi-line embedded input — wraps text like a textarea */\n\n.vkb__embedded_input--multiline {\n    white-space: pre-wrap;\n    word-break: break-word;\n    overflow-x: hidden;\n    overflow-y: auto;\n    display: block;\n    /* Fixed height derived from line count via CSS variable set inline */\n    height: calc(var(--vkb-lines, 3) * 1.5em + 12px);\n    min-height: unset;\n    align-items: unset;\n    scrollbar-width: none;\n}\n\n.vkb__embedded_input--multiline::-webkit-scrollbar {\n    display: none;\n}\n\n\n/* Mobile portrait: shift up by the activity bar height unless a transformed ancestor\n   already acts as the containing block (in which case --vkb-bottom is set to 0 there). */\n@media (max-width: 845px) and (orientation: portrait) {\n    .vkb {\n        bottom: var(--vkb-bottom, 62px);\n    }\n}\n\n/* Mobile landscape: shorter keys, generic keys fill available width. */\n@media (orientation: landscape) and (max-height: 500px) {\n    .vkb {\n        padding: 4px 4px 6px;\n        gap: 4px;\n        /* left: 0 — on narrow phones (≤768px) the section has a CSS transform which makes it\n           the fixed-positioning containing block; the section already starts after the ActivityBar. */\n    }\n\n    .vkb__key {\n        height: 31px;\n        max-width: none;\n    }\n}\n\n/* Wider landscape phones (>768px): isMobile=false means no section transforms, so the VKB\n   is viewport-relative and must skip past the ActivityBar (53px, border-box). */\n@media (orientation: landscape) and (max-height: 500px) and (min-width: 769px) {\n    .vkb {\n        left: 53px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
